"use client"

// src/components/pages/ChatPage.jsx
import { useParams, Link } from "react-router-dom"
import DashboardTemplate from "../templates/DashboardTemplate"
import ChatWidget from "../molecules/ChatWidget"

export default function ChatPage() {
  const { orderId } = useParams()

  return (
    <DashboardTemplate>
      <div className="max-w-4xl mx-auto">
        <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <div>
            <div className="flex items-center mb-2">
              <Link
                to="/owner/chats"
                className="text-amber-600 hover:text-amber-700 transition-colors duration-200 mr-2"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  ></path>
                </svg>
              </Link>
              <h1 className="text-2xl font-bold text-gray-800">Order Chat</h1>
            </div>
            <p className="text-gray-600">
              Order ID: <span className="font-mono font-medium">{orderId.slice(-6).toUpperCase()}</span>
            </p>
          </div>
          <div className="mt-4 sm:mt-0">
            <Link
              to={`/owner/order-management/${orderId}`}
              className="inline-flex items-center px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors duration-200"
            >
              <svg
                className="w-5 h-5 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                ></path>
              </svg>
              View Order Details
            </Link>
          </div>
        </div>

        <ChatWidget orderId={orderId} />

        <div className="mt-6 bg-amber-50 p-4 rounded-lg border border-amber-100">
          <h3 className="text-lg font-medium text-amber-800 mb-2">Chat Guidelines</h3>
          <ul className="space-y-2 text-sm text-amber-700">
            <li className="flex items-start">
              <svg className="h-5 w-5 text-amber-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              Respond promptly to customer inquiries
            </li>
            <li className="flex items-start">
              <svg className="h-5 w-5 text-amber-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              Keep communication professional and courteous
            </li>
            <li className="flex items-start">
              <svg className="h-5 w-5 text-amber-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              Update customers about any changes to their order
            </li>
          </ul>
        </div>
      </div>
    </DashboardTemplate>
  )
}
